import RestrictionsProvider from '@/application/providers/RestrictionsProvider'
import {validationFunctions as vf} from  '@/application/libs/validations'
import {validateFields, getFormatedError} from  '@/application/libs/validations'
import Util from  '@/application/libs/util'
import moment from 'moment'
import { t } from 'i18next'

function RestrictionsService(){
    const _getNRORG = () => Util.getLocalVar('userData').NRORG;
    const _getCDFILIAL = () => Util.getFilterInSession().CDFILIAL;
    const _getCDSERVFILI = () => Util.getFilterInSession().CDSERVFILI;
    const _getIDTIPORESTRICAO = () => Util.getFilterInSession().TPCONTRATO;
    const _getDTMESCARD = () => Util.getFilterInSession().DTMESCARD;
    
    const _accessGridRowValue = (data, keyName) => {
        return data[keyName + "_key"] || data[keyName] || null;
    };
    /**
     * Return data from grid that contains frequency
     * of plate's groups per date period.
     */
    this.getPlateGroupFrequencyGridData = ({NRVIGENCIA}) => {
        return RestrictionsProvider.getPlateGroupFrequencyGridData(NRVIGENCIA);
    };

    this.getPlateGroupProductFrequencyGridData = ({NRVIGENCIA}) => {
        return RestrictionsProvider.getPlateGroupProductFrequencyGridData(NRVIGENCIA);
    };
    
    this.getPlateFrequencyGridData = ({NRVIGENCIA}) => {
        return RestrictionsProvider.getPlateFrequencyGridData(NRVIGENCIA);
    };
    
    this.getPlateWeekdayUtilization = ({NRVIGENCIA}) => {
        return RestrictionsProvider.getPlateWeekdayUtilization(NRVIGENCIA);
    };
    
    this.getProductGroupPlateRestrictions = ({NRVIGENCIA}) => {
        return RestrictionsProvider.getProductGroupPlateRestrictions(NRVIGENCIA);
    };
    
    this.getRulesToBeFlexibleInScenarioPostProcessing = () => {
        return RestrictionsProvider.getRulesToBeFlexibleInScenarioPostProcessing();
    };
    
    this.getGruoupForNewWeekdayUsage = function(NRVIGENCIA){
        return RestrictionsProvider.getGruoupForNewWeekdayUsage(NRVIGENCIA);
    };

    this.getValidity  = (from) => {
        return RestrictionsProvider.getValidity(from);
    };
    
    this.getServicePlateGroup = (NRVIGENCIA) => {
        return RestrictionsProvider.getServicePlateGroup(NRVIGENCIA);
    };

    this.getPlateGroup = () => {
        return RestrictionsProvider.getPlateGroup();
    };

    this.getPlate = (userQuery, NRVIGENCIA) => {
        return RestrictionsProvider.getPlates(userQuery, NRVIGENCIA);
    };

    this.getProducts = (userQuery) => {
        return RestrictionsProvider.getProducts(userQuery);
    };

    this.updateDataValidity = (validity) => RestrictionsProvider.updateDataValidity(validity);

    this.exportValidityProcedureCaller = (exportValidity) => RestrictionsProvider.exportValidityProcedureCaller(exportValidity);

    this.getValidityObservations = () => RestrictionsProvider.getValidityObservations();

    const getNRFREQPRODGRPRAT = (dataset) => (dataset.find(d => d.NRFREQPRODGRPRAT) || {}).NRFREQPRODGRPRAT;
    const getNRFREQGRPRATMES = (dataset) => (dataset.find(d => d.NRFREQGRPRATMES) || {}).NRFREQGRPRATMES;
    const getNRFREQPRATMES = (dataset) => (dataset.find(d => d.NRFREQPRATMES) || {}).NRFREQPRATMES;
    this.savePlateGroupFrequencyGridData = (changedData, colName, dataset, validity) => {
        const intervalValidation = vf.interval('NRMINFREQGRPRATMES', 'NRMAXFREQGRPRATMES', 
            t('minimum_month_field_must_be_less_than_or_equal_to_maximum_month_field'));
        let __is_new = Boolean(!changedData.NRITFREQGRPRATMES);
        let validations = {
            NMGRUPOPRATO: {f: vf.withAnother(vf.notEmpty, "NRGRUPOPRATOSERV", t('group_of_dishes')), label: ""},
            NRMINFREQGRPRATMES: {f: [vf.numericalPositiveInteger, intervalValidation], label: t('minimum_month')},
            NRMAXFREQGRPRATMES: {f: [vf.numericalPositiveInteger, intervalValidation], label: t('maximum_month')},
            NRMAXFREQGRPRATSEM: {f: vf.numericalPositiveInteger, label: t('maximum_week')},
        };
        let validationResult = validateFields(changedData, validations);
        if (!validationResult.error) {
            if (!__is_new) {
                return RestrictionsProvider.saveChangedData([{
                    NRMINFREQGRPRATMES: changedData.NRMINFREQGRPRATMES,
                    NRMAXFREQGRPRATMES: changedData.NRMAXFREQGRPRATMES,
                    NRMAXFREQGRPRATSEM: changedData.NRMAXFREQGRPRATSEM,
                    NRITFREQGRPRATMES: changedData.NRITFREQGRPRATMES,
                }], 'FREQUENCIAGRUPO');
            } else {
                return RestrictionsProvider.insertData([{
                    // NRITFREQGRPRATMES, new code
                    NRFREQGRPRATMES: getNRFREQGRPRATMES(dataset),
                    NRMINFREQGRPRATMES: changedData.NRMINFREQGRPRATMES,
                    NRMAXFREQGRPRATMES: changedData.NRMAXFREQGRPRATMES,
                    NRMAXFREQGRPRATSEM: changedData.NRMAXFREQGRPRATSEM,
                    NRGRUPOPRATOSERV: changedData.NRGRUPOPRATOSERV,
                    CDFILIAL: _getCDFILIAL(),
                    CDSERVFILI: _getCDSERVFILI(),
                    DTVIGENCIA: validity.DTVIGENCIA,
                    NRVIGENCIA: validity.NRVIGENCIA,
                    NRORG: _getNRORG(),
                }], 'FREQUENCIAGRUPO');
            }
        } else {
            return Promise.resolve(getFormatedError(changedData, validations, colName, __is_new));
        }
    };
    this.saveWeekdayUtilizationGridData = (changedData, colName, _, validity) => {
        let __is_new = Boolean(!changedData.NRUTILPRATOSERV);
        let validations = {
            NMGRUPOPRATO: {f: vf.withAnother(vf.notEmpty, "NRGRUPOPRATOSERV", t('group_of_dishes')), label: ""},
        };
        let validationResult = validateFields(changedData, validations);
        let params = {
            IDUTILPRATOSERVSEG: _accessGridRowValue(changedData, "IDUTILPRATOSERVSEG") || "PREFERENCIAL",
            IDUTILPRATOSERVTER: _accessGridRowValue(changedData, "IDUTILPRATOSERVTER") || "PREFERENCIAL",
            IDUTILPRATOSERVQUA: _accessGridRowValue(changedData, "IDUTILPRATOSERVQUA") || "PREFERENCIAL",
            IDUTILPRATOSERVQUI: _accessGridRowValue(changedData, "IDUTILPRATOSERVQUI") || "PREFERENCIAL",
            IDUTILPRATOSERVSEX: _accessGridRowValue(changedData, "IDUTILPRATOSERVSEX") || "PREFERENCIAL",
            IDUTILPRATOSERVSAB: _accessGridRowValue(changedData, "IDUTILPRATOSERVSAB") || "PREFERENCIAL",
            IDUTILPRATOSERVDOM: _accessGridRowValue(changedData, "IDUTILPRATOSERVDOM") || "PREFERENCIAL",
            
            IDUTILPRATOSERVPRIM: _accessGridRowValue(changedData, "IDUTILPRATOSERVPRIM") || "PREFERENCIAL",
            IDUTILPRATOSERVSEM2: _accessGridRowValue(changedData, "IDUTILPRATOSERVSEM2") || "PREFERENCIAL",
            IDUTILPRATOSERVSEM3: _accessGridRowValue(changedData, "IDUTILPRATOSERVSEM3") || "PREFERENCIAL",
            IDUTILPRATOSERVSEM4: _accessGridRowValue(changedData, "IDUTILPRATOSERVSEM4") || "PREFERENCIAL",
            IDUTILPRATOSERVULT: _accessGridRowValue(changedData, "IDUTILPRATOSERVULT") || "PREFERENCIAL",
            IDUTILPRATOSERVFERI: _accessGridRowValue(changedData, "IDUTILPRATOSERVFERI") || "PREFERENCIAL",

        };
        if (!validationResult.error) {
            if (!__is_new) {
                params.NRUTILPRATOSERV = changedData.NRUTILPRATOSERV;
                return RestrictionsProvider.saveChangedData([params], 'UTILIZACAOPRATOSEMANA');
            } else {
                params.NRGRUPOPRATOSERV = changedData.NRGRUPOPRATOSERV;
                params.CDSERVFILI = _getCDSERVFILI();
                params.DTVIGENCIA = validity.DTVIGENCIA;
                params.NRVIGENCIA = validity.NRVIGENCIA;
                params.NRORG = _getNRORG();
                return RestrictionsProvider.insertData([params], 'UTILIZACAOPRATOSEMANA');
            }
        } else {
            return Promise.resolve(getFormatedError(changedData, validations, colName, __is_new));
        }
    };
    this.saveProductGroupPlateRestrictions = (changedData, colName, _, validity) => {
        let validations = {
            NMGRUPOPRATO: {f: vf.withAnother(vf.notEmpty, "NRGRUPOPRATOSERV", t('group_of_dishes')), label: ""},
            CDPRODUTO: {f: vf.notEmpty, label: "Produto"},
        };
        let validationResult = validateFields(changedData, validations);
        if (!validationResult.error) {
            return RestrictionsProvider.insertData([{ //todo
                // NRRESTPRODGR, new code
                CDPRODUTO: changedData.CDARVPROD_key,
                NRGRUPOPRATOSERV: changedData.NRGRUPOPRATOSERV,
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                NRVIGENCIA: validity.NRVIGENCIA,
                NRORG: _getNRORG(),
            }], 'PRODUTOGRUPOPRATORESTRICACAO');
        } else {
            return Promise.resolve(getFormatedError(changedData, validations, colName, true));
        }
    };
    this.savePlateGroupProductFrequencyGridData = (changedData, colName, dataset, validity) => {
        const intervalValidation = vf.interval('NRMINPRODGRPRAT', 'NRMAXPRODGRPRAT', 
            t('minimum_month_field_must_be_less_than_or_equal_to_maximum_month_field'));
        let __is_new = Boolean(!changedData.NRITFREQPRODGRPRAT);
        let validations = {
            NMGRUPOPRATO: {f: vf.withAnother(vf.notEmpty, "NRGRUPOPRATOSERV", t('group_of_dishes')), label: ""},
            CDPRODUTO: {f: vf.notEmpty, label: t('product')},
            NRMINPRODGRPRAT: {f: [vf.numericalPositiveInteger, intervalValidation], label: t('minimum_month')},
            NRMAXPRODGRPRAT: {f: [vf.numericalPositiveInteger, intervalValidation], label: t('maximum_month')},
            NRMAXPRODGRPRATSEM: {f: vf.numericalPositiveInteger, label: t('maximum_week')},
        };
        let validationResult = validateFields(changedData, validations);
        if (!validationResult.error) {
            if (!__is_new) {
                return RestrictionsProvider.saveChangedData([{
                    NRMINPRODGRPRAT: changedData.NRMINPRODGRPRAT,
                    NRMAXPRODGRPRAT: changedData.NRMAXPRODGRPRAT,
                    NRMAXPRODGRPRATSEM: changedData.NRMAXPRODGRPRATSEM,
                    NRITFREQPRODGRPRAT: changedData.NRITFREQPRODGRPRAT,
                }], 'FREQUENCIAGRUPOPRATOPRODUTO');
            } else {
                return RestrictionsProvider.insertData([{ //todo
                    // NRITFREQPRODGRPRAT, new code
                    NRFREQPRODGRPRAT: getNRFREQPRODGRPRAT(dataset),
                    NRMINPRODGRPRAT: changedData.NRMINPRODGRPRAT,
                    CDPRODUTO: changedData.CDARVPROD_key,
                    NRMAXPRODGRPRAT: changedData.NRMAXPRODGRPRAT,
                    NRMAXPRODGRPRATSEM: changedData.NRMAXPRODGRPRATSEM,
                    NRGRUPOPRATOSERV: changedData.NRGRUPOPRATOSERV,
                    CDFILIAL: _getCDFILIAL(),
                    CDSERVFILI: _getCDSERVFILI(),
                    DTVIGENCIA: validity.DTVIGENCIA,
                    NRVIGENCIA: validity.NRVIGENCIA,
                    NRORG: _getNRORG(),
                }], 'FREQUENCIAGRUPOPRATOPRODUTO');
            }
        } else {
            return Promise.resolve(getFormatedError(changedData, validations, colName, __is_new));
        }
    };
    this.savePlateFrequencyGridData = (changedData, colName, dataset, validity) => {
        const intervalValidation = vf.interval('NRMINFREQPRATMES', 'NRMAXFREQPRATMES', 
            t('minimum_month_field_must_be_less_than_or_equal_to_maximum_month_field'));
        let __is_new = Boolean(!changedData.NRITFREQPRATMES);
        let validations = {
            CDPRATO: {f: vf.notEmpty, label: t('plate')},
            NRMINFREQPRATMES: {f: [vf.numericalPositiveInteger, intervalValidation], label: t('minimum_month')},
            NRMAXFREQPRATMES: {f: [vf.numericalPositiveInteger, intervalValidation], label: t('maximum_month')},
            NRMAXFREQPRATSEM: {f: vf.numericalPositiveInteger, label: t('maximum_week')},
        };
        let validationResult = validateFields(changedData, validations);
        if (!validationResult.error) {
            if (!__is_new) {
                return RestrictionsProvider.saveChangedData([{
                    NRMINFREQPRATMES: changedData.NRMINFREQPRATMES,
                    NRMAXFREQPRATMES: changedData.NRMAXFREQPRATMES,
                    NRMAXFREQPRATSEM: changedData.NRMAXFREQPRATSEM,
                    CDFILIAL: _getCDFILIAL(),
                    NRITFREQPRATMES: changedData.NRITFREQPRATMES,
                    CDSERVFILI: _getCDSERVFILI(),
                    IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
                    DTMESCARD: _getDTMESCARD(),
                    CDPRATO: changedData.CDPRATO,
                    CDFILAUXPRAT: changedData.CDFILAUXPRAT
                }], 'FREQUENCIAPRATO');
            } else {
                return RestrictionsProvider.insertData([{
                    // NRITFREQPRATMES, new code
                    NRFREQPRATMES: getNRFREQPRATMES(dataset),
                    NRMINFREQPRATMES: changedData.NRMINFREQPRATMES,
                    NRMAXFREQPRATMES: changedData.NRMAXFREQPRATMES,
                    NRMAXFREQPRATSEM: changedData.NRMAXFREQPRATSEM,
                    CDFILAUXPRAT: changedData.CDFILAUXPRAT, // TODO
                    CDPRATO: changedData.CDPRATO, // TODO
                    CDFILIAL: _getCDFILIAL(),
                    CDSERVFILI: _getCDSERVFILI(),
                    DTVIGENCIA: validity.DTVIGENCIA,
                    NRVIGENCIA: validity.NRVIGENCIA,
                    IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
                    DTMESCARD: _getDTMESCARD(),
                    NRORG: _getNRORG(),
                }], 'FREQUENCIAPRATO');
            }
        } else {
            return Promise.resolve(getFormatedError(changedData, validations, colName, __is_new));
        }
    };

    const _getFormatedMonthDate = (date) => {
        if(date && date !== ""){
            return moment(date, "YYYY-MM").format("DD/MM/YYYY");
        } else {
            return null;
        }
    };
    
    this.saveValidity = (validityData, from, replicate = false, nrvigencia_origem = null) => { /*incluidos os parametros replicate e lista, caso replicate == true, a lista vai ter as pks dos itens originais para inserir no destino*/
        // do validations
        let initialDate = validityData.initialDate;
        let endDate = validityData.endDate;
        if (!initialDate) {
            return Promise.reject({ error: t('the_start_date_field_is_required') });
        } 
        
        if (initialDate && endDate && moment(initialDate, "YYYY-MM") > moment(endDate, "YYYY-MM")) {
            return Promise.reject({ error: t('invalid_range') });
        } 
        
        if (!validityData.selectedObservation && from !== 'VIGENCIAUTILIZACAOPRATOSEMANA') {
            return Promise.reject({ error: t('the_observation_field_is_required') });
        } 
        
        const data = {
            CDFILIAL: _getCDFILIAL(),
            CDSERVFILI: _getCDSERVFILI(),
            DTVIGENCIA: _getFormatedMonthDate(initialDate),
            DTVIGENCIAFIM: _getFormatedMonthDate(endDate),
            DESCRICAO: validityData.description || null,
            IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
            NRORG: _getNRORG(),
            replicate,
            nrvigencia_origem
        };

        if (validityData.selectedObservation) {
            data.CDDESCOBSFILIAL = validityData.selectedObservation.CDDESCOBSFILIAL;
        }

        return RestrictionsProvider.insertData([data], from);
        
    };

    this.saveChangeOnIdflexivelRow = (column, row) => {
        let saveObj = {};
        saveObj.NROTMREGRAFLEX = row.NROTMREGRAFLEX;
        saveObj.IDFLEXIVEL = row[column.field+'_key'];
        return RestrictionsProvider.saveIdflexivelRow(saveObj).then(()=>{
            Util.showNotification({
                text: t('save_as', {PARAM: `${moment().format('HH:mm:ss')}`}),
                title: t('rules_to_Be_Flexible_In_Scenario_PostProcessing')
            });
        }, responseError=>{
            Util.showErrorNotification({
                title: t('error_saving'),
                text:''
            });
        });
    },
    
    this.updateOrderRule = (data) => {
        return RestrictionsProvider.updateOrderRule(data).then(()=>{
          
        }, responseError=>{
           
        });
    };

    this.updRestoreFlexibleRules = () => {
        return RestrictionsProvider.updRestoreFlexibleRules().then(()=>{
          
        }, responseError=>{
           
        });
    };

    this.editPlateGroupValidity = (editedValidityData, validityID) => {
        return RestrictionsProvider.saveChangedData([{
            DESCRICAO: editedValidityData.description,
            NRVIGENCIA: validityID
        }], 'VIGENCIAGRUPOPRATO');
    };

    this.editWeekdayUtilizationValidity = (editedValidityData, validityID) => {
        return RestrictionsProvider.saveChangedData([{
            DESCRICAO: editedValidityData.description,
            NRVIGENCIA: validityID
        }], 'VIGENCIAUTILIZACAOPRATOSEMANA');
    };

    this.editProductGroupPlateRestrictionsValidity = (editedValidityData, validityID) => {
        return RestrictionsProvider.saveChangedData([{
            DESCRICAO: editedValidityData.description,
            NRVIGENCIA: validityID
        }], 'VIGENCIAPRODUTOGRUPOPRATORESTRICACAO');
    };
    
    this.editPlateGroupProductValidity = (editedValidityData, validityID) => {
        return RestrictionsProvider.saveChangedData([{
            DESCRICAO: editedValidityData.description,
            NRVIGENCIA: validityID
        }], 'VIGENCIAGRUPOPRATOPRODUTO');
    };
    
    this.editPlateValidity = (editedValidityData, validityID) => {
        return RestrictionsProvider.saveChangedData([{
            DESCRICAO: editedValidityData.description,
            NRVIGENCIA: validityID
        }], 'VIGENCIAPRATO');
    };

    this.deleteValidity = (editedValidityData, force, which, addCDFILIAL = true) => {
        let CDFILIAL = _getCDFILIAL();
        let reqData = Object.assign({
            force: force,
            CDSERVFILI: _getCDSERVFILI(),
        }, editedValidityData);
        reqData = (addCDFILIAL && {...reqData, CDFILIAL}) || reqData; 
        return RestrictionsProvider.deleteData([reqData], which);
    };
    this.removePlateGroupFrequency = (data) => {
        let dataToDelete = data.filter(el => el.NRITFREQGRPRATMES);
        let returnPromise = null;
        if(data.length) {
            returnPromise = RestrictionsProvider.deleteData(dataToDelete.map(de => {
                return { 
                    NRITFREQGRPRATMES: de.NRITFREQGRPRATMES,
                    NRFREQGRPRATMES: de.NRFREQGRPRATMES
                }
            }), "FREQUENCIAGRUPO");
        } else {
            returnPromise = Promise.resolve();
        }
        
        return returnPromise;
    };
    this.removePlateGroupProductFrequency = (data) => {
        let dataToDelete = data.filter(el => el.NRITFREQPRODGRPRAT);
        let returnPromise = null;
        if(data.length) {
            returnPromise = RestrictionsProvider.deleteData(dataToDelete.map(de => {
                return { 
                    NRITFREQPRODGRPRAT: de.NRITFREQPRODGRPRAT,
                    NRFREQPRODGRPRAT: de.NRFREQPRODGRPRAT
                }
            }), "FREQUENCIAGRUPOPRATOPRODUTO");
        } else {
            returnPromise = Promise.resolve();
        }
        
        return returnPromise;
    };
    this.removeProductGroupPlateRestrictions = (data) => {
        let dataToDelete = data.filter(el => el.NRRESTPRODGR);
        let returnPromise = null;
        if(data.length) {
            returnPromise = RestrictionsProvider.deleteData(dataToDelete.map(de => {
                return { 
                    NRRESTPRODGR: de.NRRESTPRODGR,
                }
            }), "PRODUTOGRUPOPRATORESTRICACAO");
        } else {
            returnPromise = Promise.resolve();
        }
        
        return returnPromise;
    };
    this.removeWeekdayUsage = (data) => {
        let dataToDelete = data.filter(el => el.NRUTILPRATOSERV);
        let returnPromise = null;
        if(data.length) {
            returnPromise = RestrictionsProvider.deleteData(dataToDelete.map(de => {
                return { 
                    NRUTILPRATOSERV: de.NRUTILPRATOSERV,
                }
            }), "UTILIZACAOPRATOSEMANA");
        } else {
            returnPromise = Promise.resolve();
        }
        
        return returnPromise;
    };
    this.removePlateFrequency = (data) => {
        let dataToDelete = data.filter(el => el.NRITFREQPRATMES);
        let returnPromise = null;
        if(data.length) {
            returnPromise = RestrictionsProvider.deleteData(dataToDelete.map(de => {
                return { 
                    NRITFREQPRATMES: de.NRITFREQPRATMES,
                    NRFREQPRATMES: de.NRFREQPRATMES
                }
            }), "FREQUENCIAPRATO");
        } else {
            returnPromise = Promise.resolve();
        }
        
        return returnPromise;
    };

}

export default new RestrictionsService();